module.exports = {
    catalogUrl: "https://nginx-main.up.railway.app",
    catalogTitle: "dClimate STAC Browser",
    catalogImage: "https://lh3.googleusercontent.com/rd-d/ALs6j_FkTcodpn1DmeGRNZ4s7j3WdxZavkyU87xmVrQzNOkxidpqcnRPdEREQGcFk8g3BiWKtl2j3MB9R2MiAvX0r4vnAn6-TTqHYPp6TKiNdS2nhLY2ccYBI2H_8UIEQ6u4Mn_PX-cTDTsC2Wl3UfFezB4lc5HpEI3B3OxAxnT5a-6T1TsD0hSCZbxhtmQyEVWXgJgrX5QJyeD_l1FkUObqAfYnkR2ZeHc8N2lm4ZouYG14Q1bTvNZgGuDs2p-MMFo3KaZuLKfS_xFfy98oUxCvNmKiX_4N0KbGIYgHJ_M4g7qrpMSYIxM6-9BFqfIXDfOT99u5jwZpaZkCUA_JlBh-QR82yZ2d2BbTJBi_z3gwedtlDbAiyLjyOU660yZm-E5CjMofGQHLU81lOjNHBkThfLZx5xggGPgS9wDmieHQZPHnBnUqkyVM3nBdsMTz0IhNwfe6az6WxusAbVjkBTl6Pm_fknn5BbWajv2yfOvIOtN-f_ZVs1xuiuzspKDHdCT8V0Wwx_rXwIQkorjHFj8laOn2OL5nDyd_nMTSo7-YFuGOWMJu37emUeyfZykrkKdB9d2oFgdguMVjzGxFH8hsRMhoubpFteItburdr2JLZR54la3UbHixqSyGLAM-JbP2Wmb5KjSKZaJRiuclQ9W-KfHGnBKMlUPLE4xsd91u8EkLmHqaDhcCugN7zmV_qEC5cpZrupadjh8IRfNhri-JR_FKEbQroGzQpjDCpxneHdu_9gjeCHiZwDfO59MS42Iyj1VZLPOe3wFAywA5dIZ1NlBXka5y8x1ARxTeaVRySeQwxB2YHcr7qLHWhNg5JcqBrINaAKWgH9CA7iSu_E8lMmveqFcdfk2aLIz4vmMDODFY901-vHCAKShq_Wd6dN8Xki5x8dODyShj67D0ugWfUqEpxMQnbj559Yv8U9j1pKcy8SGsi8RUqFlA3h0tGXGnd6Qtl4ihlgiOFx8VIYdj6cPx_AO5kCeHdpwqJIQjMxgMxso1ja0K62ykI3XkKXBI7jf3ozxFr1L_D2OniWuM6MvyjVaHkt40M5eQInorbGInj-Z0-wJIvlmqjsHOnXvGW3IOm6G_WF6ek1tBaieKnvJ_UrHNG6mcwLGRwjKVUq49wEgHPDgO5XoeY6wGMUbCVTVJIzKTMKeFbTFxwN22u-ezSVpnspuTbU511hUDjq9Prt1ffud0=w3008-h1568?auditContext=forDisplay",
    allowExternalAccess: true, // Must be true if catalogUrl is not given
    allowedDomains: [],
    detectLocaleFromBrowser: true,
    storeLocale: true,
    locale: "en",
    fallbackLocale: "en",
    supportedLocales: [
        "de",
        "es",
        "en",
        "fr",
        "it",
        "ro"
    ],
    apiCatalogPriority: null,
    useTileLayerAsFallback: true,
    displayGeoTiffByDefault: false,
    buildTileUrlTemplate: ({href, asset}) => "https://titiler-main.up.railway.app/cog/tiles/{z}/{x}/{y}@2x?url=" + encodeURIComponent(asset.href.startsWith("/vsi") ? asset.href : href),
    stacProxyUrl: null,
    pathPrefix: "/",
    historyMode: "history",
    cardViewMode: "cards",
    cardViewSort: "asc",
    showThumbnailsAsAssets: false,
    stacLint: true,
    geoTiffResolution: 128,
    redirectLegacyUrls: false,
    itemsPerPage: 12,
    defaultThumbnailSize: null,
    maxPreviewsOnMap: 50,
    crossOriginMedia: null,
    requestHeaders: {},
    requestQueryParameters: {},
    preprocessSTAC: null,
    authConfig: null,
};